import { env } from '../env';
import { findIndex, replace, startsWith } from 'lodash';

/**
 * Here goes the global constants
 */
export const APPLICATION_ID = getHostProperty(env.REACT_APP_MULTIHOST_DOMAIN_ID_BOUTIQUE);
export const REDIRECT_LINK = getHostProperty(env.REACT_APP_MULTIHOST_REDIRECT_LINK);
export const REDIRECT_URL = getHostProperty(env.REACT_APP_MULTIHOST_REDIRECT_URL);
export const APP_NAME = getHostProperty(env.REACT_APP_MULTIHOST_NAME).replace("''", "'");
export const BRAND_NAME = getHostProperty(env.REACT_APP_MULTIHOST_BRAND_NAME).replace("''", "'");
export const APP_DESCRIPTION = '';

export const HAS_INSTANT_DISCOUNT = getHostProperty(
    env.REACT_APP_MULTIHOST_HAS_INSTANT_DISCOUNT,
    true
);
export const NO_DISCOUNT = ['198'].includes(APPLICATION_ID);
export const INSTANT_DISCOUNT_LOGIN_REQUIRED_IDS = ['124', '146', '164', '221', '227'];

export const MINIMAL_HEADER = ['117'].includes(APPLICATION_ID);
export const MINIMAL_FOOTER = ['117'].includes(APPLICATION_ID);
export const HIDE_HEADER = ['216'].includes(APPLICATION_ID);

export const NO_USER_ID = getHostProperty(env.REACT_APP_MULTIHOST_NO_USER_ID, true);
export const NO_FRONT_APPS = getHostProperty(env.REACT_APP_MULTIHOST_NO_FRONT, true);
export const USE_PARITY = getHostProperty(env.REACT_APP_MULTIHOST_USE_PARITY, true);
export const HAS_LOGO = getHostProperty(env.REACT_APP_MULTIHOST_HAS_LOGO, true);
export const SSO_URL = getHostProperty(env.REACT_APP_MULTIHOST_SSO_URL);
export const CONTACT_EMAIL_ADDRESS = getHostProperty(env.REACT_APP_MULTIHOST_CONTACT_EMAIL_ADDRESS);
export const CONTACT_PHONE_NUMBER = getHostProperty(env.REACT_APP_MULTIHOST_CONTACT_PHONE_NUMBER);
export const COMPANY_NAME_AND_IDENTIFIER = getHostProperty(
    env.REACT_APP_MULTIHOST_COMPANY_NAME_AND_IDENTIFIER
);
export const PRIMARY_COLOR = getHostProperty(env.REACT_APP_MULTIHOST_COLOR_PRIMARY);
export const REDIRECT_CLIENT_URL = getHostProperty(
    env.REACT_APP_MULTIHOST_AUTO_REDIRECT_CLIENT_URL,
    true
);

export const COIN_NAME = getHostProperty(env.REACT_APP_MULTIHOST_COIN_NAME);

export const REDIRECT_SAV_CLIENT = getHostProperty(env.REACT_APP_SAV_URL_REDIRECTION);
export const USE_FRENCH_URL = getHostProperty(env.REACT_APP_USE_FRENCH_URL, true);

export const DIDOMI_PUBLIC_API_KEY = env.REACT_APP_DIDOMI_PUBLIC_API_KEY;
export const DIDOMI_NOTICE_ID = getHostProperty(env.REACT_APP_DIDOMI_NOTICE_ID);
export const DIDOMI_VENDOR_GOOGLE_ID = env.REACT_APP_DIDOMI_VENDOR_GOOGLE_ID;

export const APPLICATION_LOCALE = getHostProperty(env.REACT_APP_DOMAIN_i18n_LOCALES);
// Pays de la boutique (ISO 3166-1 alpha-2), FR par défaut
export const APPLICATION_COUNTRY = getHostProperty(env.REACT_APP_MULTIHOST_COUNTRY || '') || 'FR';
// Indicatif téléphonique international du pays de la boutique
const PHONE_DIALING_CODES = { FR: '+33', BE: '+32', IT: '+39', ES: '+34' };
export const PHONE_DIALING_CODE =
    PHONE_DIALING_CODES[APPLICATION_COUNTRY] || PHONE_DIALING_CODES.FR;

export const CONTEXT_ROOT = withDomain('');
export const API_ROOT = withDomain(env.REACT_APP_API_ROOT, true);
export const DOMAIN_COOKIE = withDomain('', false, true);

export const STATIC_ROOT = withStaticDomain('', env.NODE_ENV === 'development');
export const APPLICATION_SPECIFIC_STATIC_ROOT = `${STATIC_ROOT}/applicationspecifics/${APPLICATION_ID}`;
export const LARGE_LOGO_ROOT = withStaticDomain(env.REACT_APP_STATIC_LARGE_LOGO_ROOT);
export const LOGO_ROOT = withStaticDomain(env.REACT_APP_STATIC_LOGO_ROOT);
export const STATIC_CMS_ROOT = withStaticDomain(env.REACT_APP_STATIC_CMS_ROOT);
export const STATIC_RESOURCES_ROOT = withStaticDomain(env.REACT_APP_STATIC_RESOURCES_ROOT);

export const URL_PAGE_FACEBOOK = '';
export const URL_PAGE_TWITTER = '';
export const URL_PAGE_GOOGLEPLUS = '';

export const PAYMENT_THRESHOLD = 10;

export const IS_DEV = env.NODE_ENV === 'development';
export const IS_STAGING = env.REACT_APP_PROFILE === 'preproduction';
export const IS_PROD = env.NODE_ENV === 'production';

export const DATE_FORMAT_REDUXFORM = 'yyyy-mm-dd';

// action input reduxform change
export const REDUX_FORM_CHANGE = '@@redux-form/CHANGE';

export const TIMER_MS_INTERSTITIEL = 5500;
export const TIMER_MS_SSO = 5000;

export const FAQ_ID_WHY_CASHBACK_INVALIDATED =
    env.REACT_APP_FAQ_ID_WHY_CASHBACK_INVALIDATED || null;

export const GA_TRACKING_NUMBER_PLEBICOM = getHostProperty(
    env.REACT_APP_GA_TRACKING_NUMBER_PLEBICOM
);

export const CHECKOUT_API_KEY = env.REACT_APP_CHECKOUT_API_KEY;
export const CHECKOUT_RISK_URL = env.REACT_APP_CHECKOUT_RISK_URL;

export const GOOGLE_PAY_MERCHANT_ID = env.REACT_APP_GOOGLE_PAY_MERCHANT_ID;

export const PAYPAL_API_KEY = env.REACT_APP_PAYPAL_API_KEY;

export const IGRAAL_ID = '117';
export const IGRAAL_EXTERNAL_REDIRECT_URL = 'https://fr.igraal.com/gift-cards';

export const ERHA_CHAT_SCRIPT_URL = 'https://console.erha.ai/erha-chat.js';
export const ERHA_CHAT_API_URL = 'https://api.erha.ai';
export const ERHA_CHAT_KEYS = {
    '204': 'chat_5ad28ce7bce96a1f1dc22248'
};
export const ERHA_CHAT_KEY = ERHA_CHAT_KEYS[APPLICATION_ID];

export function withDomain(uri, api = false, hostOnly = false) {
    if (startsWith(uri, 'http')) {
        return uri;
    }

    let path = uri;
    if (!startsWith(uri, '/')) {
        path = `/${uri}`;
    }

    const host = api ? replace(window.location.host, ':3000', ':8080') : window.location.host;

    return hostOnly ? host : `${window.location.protocol}//${host}${path}`;
}

export function withStaticDomain(path, isDev = false) {
    if (isDev) {
        return `${window.location.protocol}//${window.location.host}${env.REACT_APP_DOMAIN_STATIC_DEV}`;
    }

    const i18nHostnames = env.REACT_APP_DOMAIN_i18n_HOSTS.split(',');
    const i18nStaticHostnames = env.REACT_APP_DOMAIN_i18n_STATIC_HOSTS.split(',');

    const hostnameIndex = findIndex(i18nHostnames, function(o) {
        return o === window.location.host;
    });
    if (hostnameIndex < 0) {
        return `https://${i18nStaticHostnames[0]}${path}`;
    }

    return `https://${i18nStaticHostnames[hostnameIndex]}${path}`;
}

export function getHostProperty(prop, isBoolean) {
    const i18nHostnames = env.REACT_APP_DOMAIN_i18n_HOSTS.split(',');
    const i18nprop = prop.split(',');

    const hostnameIndex = findIndex(i18nHostnames, function(o) {
        return o === window.location.host;
    });
    if (hostnameIndex < 0) {
        return i18nprop[0];
    }

    if (isBoolean) {
        return i18nprop[hostnameIndex] === 'true';
    }

    return i18nprop[hostnameIndex];
}



// WEBPACK FOOTER //
// ./src/constants/index.js